import type { Card } from '../../types';

/** Starter support (ADR-0015 §19). Common 1×1, free (no die cost). An activated
 * card — it fires on demand during the player's assign phase (via the engine's
 * `activateCard` intent), not at turn resolution. Rerolls one of the player's
 * dice; the player picks which. `oncePerTurn` caps it at one rescue per turn so
 * the free utility can't be exploited (Dicey-Dungeons "let me try once"). */
export const REROLL: Card = {
  id: 'reroll',
  name: 'Reroll',
  type: 'support',
  rarity: 'common',
  size: { w: 1, h: 1 },
  cost: [],
  effects: [{ kind: 'rerollDice', count: 1 }],
  oncePerTurn: true,
};
